// Foot-nav compartilhado dos wizards de onboarding (workspace + org). Antes
// estava duplicado byte-a-byte nos dois (DEBT-014).
import { Button } from "@/components/common";

interface Props {
  // Mostra "Voltar" quando não é o primeiro step.
  canGoBack: boolean;
  onBack: () => void;
  // Mostra "Pular essa etapa" quando o step atual é opcional.
  canSkip: boolean;
  onSkip: () => void;
  onNext: () => void;
  isLast: boolean;
  isSubmitting?: boolean;
  // Desabilita "Continuar/Concluir" quando a validação client-side falha.
  canContinue?: boolean;
}

export function OnbFootNav({
  canGoBack,
  onBack,
  canSkip,
  onSkip,
  onNext,
  isLast,
  isSubmitting,
  canContinue = true,
}: Props) {
  return (
    <div className="onb-foot">
      <div className="onb-foot-left">
        {canGoBack && (
          <Button variant="ghost" iconLeft="arrow-left" onClick={onBack}>
            Voltar
          </Button>
        )}
      </div>
      <div className="onb-foot-right">
        {canSkip && (
          <Button variant="ghost" onClick={onSkip}>
            Pular essa etapa
          </Button>
        )}
        <Button
          variant="primary"
          iconRight={isLast ? "check" : "arrow-up-right"}
          onClick={onNext}
          disabled={isSubmitting || !canContinue}
        >
          {isSubmitting ? "Criando..." : isLast ? "Concluir" : "Continuar"}
        </Button>
      </div>
    </div>
  );
}
